import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import Layout from "@/components/Layout";
import Catalogue from "@/pages/Catalogue";
import Produit from "@/pages/Produit";
import Panier from "@/pages/Panier";
import Succes from "@/pages/Succes";
import Annulee from "@/pages/Annulee";
import Admin from "@/pages/Admin";
import Connexion from "@/pages/Connexion";
import MesCommandes from "@/pages/MesCommandes";
import AuthCallback from "@/pages/AuthCallback";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <Layout>
            <Routes>
              <Route path="/" element={<Catalogue />} />
              <Route path="/produit/:productId" element={<Produit />} />
              <Route path="/panier" element={<Panier />} />
              <Route path="/succes" element={<Succes />} />
              <Route path="/annulee" element={<Annulee />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/connexion" element={<Connexion />} />
              <Route path="/login" element={<Connexion />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/mes-commandes" element={<MesCommandes />} />
            </Routes>
          </Layout>
          <Toaster theme="dark" position="top-center" richColors />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
